import React from 'react';
import PropTypes from 'prop-types';
import { MenuItem, Menu } from '@material-ui/core';
import { Translate, I18n } from 'react-redux-i18n';
import { Icon } from 'front-onceforall-core';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
export const UserMenuView = props => {
  const userMenuBtnRef = React.useRef(null);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx("button", {
      type: "button",
      ref: userMenuBtnRef,
      className: "button-square",
      onClick: props.onSwitchUserMenu,
      title: I18n.t('menu.profile'),
      children: /*#__PURE__*/_jsx(Icon, {
        icon: "user"
      })
    }), /*#__PURE__*/_jsxs(Menu, {
      id: "user-menu",
      anchorEl: userMenuBtnRef.current,
      open: props.isUserMenuOpen,
      onClose: props.onSwitchUserMenu,
      anchorOrigin: {
        vertical: 'top',
        horizontal: 'right'
      },
      children: [/*#__PURE__*/_jsx("div", {
        "data-id": "account",
        onClick: props.onUserSettingsSelect,
        children: /*#__PURE__*/_jsx(MenuItem, {
          name: "account",
          onClick: props.onSwitchUserMenu,
          children: /*#__PURE__*/_jsxs("span", {
            className: "inline-container",
            children: [/*#__PURE__*/_jsx(Icon, {
              icon: "cog"
            }), /*#__PURE__*/_jsx(Translate, {
              value: "user.account"
            })]
          })
        })
      }), /*#__PURE__*/_jsx("div", {
        "data-id": "terms",
        onClick: props.onOpenTermsAndConditions,
        children: /*#__PURE__*/_jsx(MenuItem, {
          name: "terms",
          onClick: props.onSwitchUserMenu,
          children: /*#__PURE__*/_jsxs("span", {
            className: "inline-container",
            children: [/*#__PURE__*/_jsx(Icon, {
              icon: "info"
            }), /*#__PURE__*/_jsx(Translate, {
              value: "textsToValidate.termsAndConditions"
            })]
          })
        })
      }), /*#__PURE__*/_jsx("div", {
        "data-id": "privacyPolicy",
        onClick: props.onOpenPrivacyPolicy,
        children: /*#__PURE__*/_jsx(MenuItem, {
          name: "privacyPolicy",
          onClick: props.onSwitchUserMenu,
          children: /*#__PURE__*/_jsxs("span", {
            className: "inline-container",
            children: [/*#__PURE__*/_jsx(Icon, {
              icon: "info"
            }), /*#__PURE__*/_jsx(Translate, {
              value: "textsToValidate.privacyPolicy"
            })]
          })
        })
      }), /*#__PURE__*/_jsx("div", {
        "data-id": "logout",
        onClick: props.onLogout,
        children: /*#__PURE__*/_jsx(MenuItem, {
          name: "logout",
          onClick: props.onSwitchUserMenu,
          children: /*#__PURE__*/_jsxs("span", {
            className: "inline-container",
            children: [/*#__PURE__*/_jsx(Icon, {
              icon: "exit"
            }), /*#__PURE__*/_jsx(Translate, {
              value: "action.logout"
            })]
          })
        })
      })]
    })]
  });
};
UserMenuView.propTypes = {
  onUserSettingsSelect: PropTypes.func.isRequired,
  onOpenTermsAndConditions: PropTypes.func.isRequired,
  onOpenPrivacyPolicy: PropTypes.func.isRequired,
  onLogout: PropTypes.func.isRequired,
  onSwitchUserMenu: PropTypes.func.isRequired,
  isUserMenuOpen: PropTypes.bool.isRequired
};
export default UserMenuView;